"use client";

import { ExternalLink, Info, Shield, Globe, Settings } from "lucide-react";
import { useTranslations } from "next-intl";

import { Button } from "@/shared/ui/buttons/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/shared/ui/cards/card";
import { Badge } from "@/shared/ui/data-display/badge";

export function TwitchLimitationsInfo() {
  const tUi = useTranslations("Ui");
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Info className="h-5 w-5 text-blue-500" />
          {tUi("twitchLimitationsInfo.ogranicheniyaVstraivaniyaTwitch")}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <Shield className="h-5 w-5 text-red-500 mt-0.5" />
              <div>
                <h4 className="font-semibold text-sm">{tUi("twitchLimitationsInfo.bezopasnostDomenov")}</h4>
                <p className="text-xs text-muted-foreground">
                  {tUi("twitchLimitationsInfo.twitchTrebuetRegistratsiiDomenov")}
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <Globe className="h-5 w-5 text-orange-500 mt-0.5" />
              <div>
                <h4 className="font-semibold text-sm">{tUi("twitchLimitationsInfo.httpsObyazatelen")}</h4>
                <p className="text-xs text-muted-foreground">
                  {tUi("twitchLimitationsInfo.vstraivanieRabotaetTolkoNa")}
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <Settings className="h-5 w-5 text-green-500 mt-0.5" />
              <div>
                <h4 className="font-semibold text-sm">{tUi("twitchLimitationsInfo.nastroykaDomena")}</h4>
                <p className="text-xs text-muted-foreground">
                  {tUi("twitchLimitationsInfo.dobavteVashDomenV")}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-4 border-t">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Badge variant="outline" className="text-xs">
                Текущий домен:{" "}
                {typeof window !== "undefined"
                  ? window.location.host
                  : "localhost:3000"}
              </Badge>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={() =>
                window.open("https://dev.twitch.tv/console/apps", "_blank")
              }
            >
              <ExternalLink className="h-3 w-3 mr-1" />
              Twitch Console
            </Button>
          </div>
        </div>

        <div className="bg-blue-50 dark:bg-blue-950/20 p-3 rounded-lg">
          <p className="text-xs text-blue-700 dark:text-blue-300">
            <strong>{tUi("twitchLimitationsInfo.reshenie")}</strong> Зарегистрируйте ваш домен в Twitch
            Developer Console, или используйте кнопку &quot;Смотреть на
            Twitch&quot; для просмотра стримов.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
